import { objectTypes, actionNames, actionPrefixes } from "@newsela/snitch";
import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";

export const NO_CLEAR_FILTERS: string[] = [
  LangstonParameterSchema.sort.key,
  LangstonParameterSchema.page.key,
];

export const NO_SHOW_FILTERS: string[] = [
  LangstonParameterSchema.page.key,
  LangstonParameterSchema.needle.key,
  LangstonParameterSchema.sort.key,
  LangstonParameterSchema.content_types.key,
];

type eventPropertiesType = "clear" | "collapse" | "show";

const EventPropertiesDescription: Record<eventPropertiesType, string> = {
  clear: "Clear search filters on the new Langston search page",
  collapse: "Collapse all search filters chips on the new Langston search page",
  show: "Show all search filters chips on the new Langston search page",
};

export const eventProperties = (type: eventPropertiesType) => ({
  objectType: objectTypes.content,
  actionPrefix: actionPrefixes.initiate,
  actionName: actionNames.filter,
  streamProperties: {
    description: EventPropertiesDescription[type],
  },
});

export const MAX_FILTERS_DISPLAY_COLLAPSED = 4;
